import { formatFullName, maskSsn } from 'platform/shared/health-apps';
import { formatDateShort } from 'platform/utilities/date';
import PropTypes from 'prop-types';
import React from 'react';
import content from '../../locales/en/content.json';
import PrefillConfirmationReview from './PrefillConfirmationReview';

const buildRows = ({ applicantName, applicantDob, applicantMemberNumber }) => [
  {
    label: content['supplemental--applicant-name-review-label'],
    value: formatFullName(applicantName, { includeMiddle: true }),
  },
  {
    label: content['supplemental--applicant-dob-review-label'],
    value: applicantDob ? formatDateShort(applicantDob) : '',
  },
  {
    label: content['supplemental--applicant-ssn-label'],
    value: maskSsn(applicantMemberNumber),
  },
];

const EnrollmentStatusReview = ({ data = {}, title }) => (
  <PrefillConfirmationReview rows={buildRows(data)} title={title} />
);

EnrollmentStatusReview.propTypes = {
  data: PropTypes.shape({
    applicantDob: PropTypes.string,
    applicantMemberNumber: PropTypes.string,
    applicantName: PropTypes.shape({
      first: PropTypes.string,
      last: PropTypes.string,
      middle: PropTypes.string,
      suffix: PropTypes.string,
    }),
  }),
  title: PropTypes.node,
};

export default EnrollmentStatusReview;
